import { render } from "./LineHeight.vue?vue&type=template&id=305a8a0a&scoped=true"
import script from "./LineHeight.vue?vue&type=script&lang=ts"
export * from "./LineHeight.vue?vue&type=script&lang=ts"

import "./LineHeight.vue?vue&type=style&index=0&id=305a8a0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-305a8a0a"

export default script